"use client";
import { v4 as uuidv4 } from "uuid";
import HomepageHeroCarousel from "@/components/Homepage/HomepageHero/components/HomepageHeroCarousel";
import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";
import type { HomepageOptimizationV3TestResult } from "@/monarch/rules/homepageOptimizationV3/types";
import BaseHomepageHeroMarketplace from "./BaseHomepageHeroMarketplace";

export default function HomepageHeroMarketplace() {
  return (
    <MonarchDataConsumer<HomepageOptimizationV3TestResult>
      experimentKey="useHomepageOptimizationV3"
      render={(testResult) => {
        const { data } = testResult;

        if (!data?.sections) {
          return <BaseHomepageHeroMarketplace />;
        }

        if (data.sections.length === 1) {
          const section = data.sections[0];
          const primaryCta =
            section.primaryCtaLink && section.primaryCtaText
              ? {
                  url: section.primaryCtaLink,
                  label: section.primaryCtaText,
                }
              : undefined;
          const secondaryCta =
            section.secondaryCtaLink && section.secondaryCtaText
              ? {
                  url: section.secondaryCtaLink,
                  label: section.secondaryCtaText,
                }
              : undefined;
          return (
            <BaseHomepageHeroMarketplace
              {...section}
              key={uuidv4()}
              primaryCta={primaryCta}
              secondaryCta={secondaryCta}
              desktopImage={section.imageUrlDesktop}
              tabletImage={section.imageUrlTablet}
              mobileImage={section.imageUrlMobile}
              titleColor={section.titleTextColor}
              descriptionColor={section.descriptionTextColor}
            />
          );
        }

        const sections = data.sections.map((section) => (
          <BaseHomepageHeroMarketplace
            {...section}
            key={uuidv4()}
            primaryCta={
              section.primaryCtaLink && section.primaryCtaText
                ? {
                    url: section.primaryCtaLink,
                    label: section.primaryCtaText,
                  }
                : undefined
            }
            secondaryCta={
              section.secondaryCtaLink && section.secondaryCtaText
                ? {
                    url: section.secondaryCtaLink,
                    label: section.secondaryCtaText,
                  }
                : undefined
            }
            desktopImage={section.imageUrlDesktop}
            tabletImage={section.imageUrlTablet}
            mobileImage={section.imageUrlMobile}
            titleColor={section.titleTextColor}
            descriptionColor={section.descriptionTextColor}
            className="h-full w-full mx-auto pb-32 sm:pb-32"
            headingLevel="h2"
          />
        ));

        return (
          <HomepageHeroCarousel
            pageTitle={data.pageTitle}
            sections={sections}
            useAutoplay={data.carouselAutoplay}
            autoplayDelay={data.carouselAutoplayDelay}
          />
        );
      }}
    />
  );
}
